export default __webpack_public_path__ + "static/media/insta.e162c257.png";